/** Shared with the tenant-wide library page; does not broaden file access. */
export const DOCUMENT_LIBRARY_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
  // Reachable as of C1: ./layout.tsx now admits COMPLIANCE_OFFICER, matching the
  // route rule route-access.ts already declared for documents/expiring. Before
  // that the layout redirected the role to /overview before this gate ran.
  'COMPLIANCE_OFFICER',
  'QUALITY_OFFICER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'CASE_MANAGER',
  'CLINICAL_LEAD',
  'REGISTERED_NURSE',
] as const;
